import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Heading,
  Description,
  Button,
  ButtonGroup,
  ExternalLink,
} from '@studio/legacy-components';

const SEGMENT_INSTALL_DOC =
  'https://docs.appcues.com/article/26-install-appcues-segment';

const SegmentModal = ({ onClose, open }) => (
  <Modal visible={open} onClose={onClose}>
    <Heading>Install with Segment</Heading>
    <Description>
      Segment is a third party service that routes data from your app to many
      different services, and gives you central control.
    </Description>
    <Description>
      If you already have Segment, you can install Appcues instantly!
    </Description>
    <ButtonGroup right>
      <Button
        kind="primary"
        forwardedAs={ExternalLink}
        href={SEGMENT_INSTALL_DOC}
        onClick={onClose}
      >
        Get Started
      </Button>
      <Button kind="secondary" onClick={onClose}>
        Cancel
      </Button>
    </ButtonGroup>
  </Modal>
);

SegmentModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export default SegmentModal;
